import { useMemo } from "react";
import { useAppendSearchParams } from "./useAppendSearchParams";

export interface FilterModel {
  name: string;
  value: string | string[];
  fieldNames?: string[],
}

function upperCaseFirstChar(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

function lowerCaseFirstChar(str: string): string {
  return str.charAt(0).toLowerCase() + str.slice(1);
}

const prefix = "filter";

export const useFiltersSearchParams = (id?: string): {
  filters: FilterModel[],
  setFilters: (filters: FilterModel[]) => void,
  updateFilter: (filter: FilterModel) => void,
} => {
  const [searchParams, setSearchParams] = useAppendSearchParams();
  // const [savedData, setSsavedData] = useState();

  const setFilters = (filters: FilterModel[]) => {
    const obj: Record<string, string | string[] | undefined> = {};
    filters.forEach((f) => {
      obj[prefix + upperCaseFirstChar(f.name)] = f.value || undefined;
    });

    setSearchParams(obj);
  };

  const updateFilter = (filter: FilterModel) => {
    const obj = {
      ...searchParams,
      [prefix + upperCaseFirstChar(filter.name)]: filter.value || undefined,
    };

    setSearchParams(obj);
  };

  const filters = useMemo(() => {
    const result: FilterModel[] = [];
    for (const [key, value] of searchParams) {
      if (key.startsWith(prefix)) {
        result.push({
          name: lowerCaseFirstChar(key.replace(prefix, "")),
          value,
        });
      }
    }
    return result;
  }, [searchParams, id]);

  return { filters, setFilters, updateFilter };
};
